import * as _ from "lodash"
import {Schema} from "js-data";
import * as PASchema from "./PAdbSchema";
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet, 
    KeyGenSpecs_default,
} from "./PAdbSchema";


export const WB_User_Group_Relationship =new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'UserGroupRs', // optional
    description: 'Schema for WB_UsrGrpR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_USRGRPR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_USRGRP_ID": {
            "type": "number"
        },
        "WB_USRGRP_ID_PRNT": {
            "type": "number"
        },
        "WB_USRGRPH_ID": {
            "type": "number"
        },
        "EFFECTIVE_START_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "EFFECTIVE_END_DT": {
            "type": "string",
            "default": "99991231",
            "length": 8
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }

    },
})

export const WB_User_Group_Relationship_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_User_Group_Hierarchy]: {foreignKey: 'WB_USRGRPH_ID', foreignKeyImmutable: true, localField: 'UserGroupHierarchy'},
        [PASchema.esWB_User_Group]: [{
            foreignKey: 'WB_USRGRP_ID_PRNT',
            foreignKeyImmutable: true,
            localField: 'Parent',
            createIndex: true
        },
            {foreignKey: 'WB_USRGRP_ID', foreignKeyImmutable: true, localField: 'Child', createIndex: true}]

    }
}


export const WB_User_Group_SalesArea =new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Partitions', // optional
    description: 'Schema for WB_UsrGrpSAR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_USRGRPSAR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_USRGRP_ID": {
            "type": "number"
        },
        "WB_SALESAREA_ID": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    },
})

export const WB_User_Group_SalesArea_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_User_Group]: {foreignKey: 'WB_USRGRP_ID', foreignKeyImmutable: true, localField: 'UserGroup'},
        [PASchema.esWB_SalesArea]: {foreignKey: 'WB_SALESAREA_ID', foreignKeyImmutable: true, localField: 'SalesArea'},

    }
}

export const WB_User_Group_Type = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Partitions', // optional
    description: 'Schema for WB_UsrGrpM records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_USRGRPM_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_MDSET_ID": {
            "type": "number"
        },
        "USRGRPM_ID": {
            "type": "string",
            "length": 50
        },
        "USRGRPM_NAME": {
            "type": "string",
            "length": 256
        },
        "COMMENTS": {
            "type": "string",
            "length": 1333
        },
        "PARENT_SHOW_IND": {
            "type": "string",
            "length": 1
        },
        "SCOPE_SHOW_IND": {
            "type": "string",
            "length": 1
        },
        "PLANS_SHOW_IND": {
            "type": "string",
            "length": 1
        },
        "CHILDREN_SHOW_IND": {
            "type": "string",
            "length": 1
        },
        "ROLES_SHOW_IND": {
            "type": "string",
            "length": 1
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number",
            "default": ""
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }

    },
})

export const WB_User_Group_Type_JSData_RELs = {
    hasMany : {
        [PASchema.esWB_User_Group]: {foreignKey: 'WB_USRGRPM_ID', foreignKeyImmutable: true, localField: 'UserGroups'},

    },
    belongsTo:{
        [PASchema.esWB_MasterData_Set]:{foreignKey: 'WB_MDSET_ID', foreignKeyImmutable: true, localField: 'MDSet'}
    }
}

export const WB_User_Group_Hierarchy = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Partitions', // optional
    description: 'Schema for WB_UsrGrpH records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_USRGRPH_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "USRGRPH_ID": {
            "type": "string",
            "length": 50
        },
        "USRGRPH_NAME": {
            "type": "string",
            "length": 256
        },
        "WB_MDSET_ID": {
            "type": "number"
        },
        "WB_SALESORG_ID": {
            "type": "number"
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    },
})

export const WB_User_Group_Hierarchy_JSData_RELs = {
    hasMany : {
        [PASchema.esWB_User_Group]: {foreignKey: 'WB_USRGRPM_ID', foreignKeyImmutable: true, localField: 'UserGroups'},

    },
    belongsTo:{
        [PASchema.esWB_MasterData_Set]:{foreignKey: 'WB_MDSET_ID', foreignKeyImmutable: true, localField: 'MDSet'},
        [PASchema.esWB_SalesOrg]:{foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg'},

    }
}

// Dictionaries
//-- Schemas
_.defaults(dctSchemaByEntitySet,
    {
        [PASchema.esWB_User_Group_Relationship]: WB_User_Group_Relationship,
        [PASchema.esWB_User_Group_SalesArea]: WB_User_Group_SalesArea,
        [PASchema.esWB_User_Group_Type]: WB_User_Group_Type,
        [PASchema.esWB_User_Group_Hierarchy]: WB_User_Group_Hierarchy,
    })


//-- Table Names
_.defaults(dctTableNameByEntitySet,
    {
        [PASchema.esWB_User_Group_Relationship]: "/AZR/WB_USRGRPR",
        [PASchema.esWB_User_Group_SalesArea]: "/AZR/WB_USRGRPSAR",
        [PASchema.esWB_User_Group_Type]: "/AZR/WB_USRGRPM",
        [PASchema.esWB_User_Group_Hierarchy]: "/AZR/WB_USRGRPH",
    })


//-- Logical Key
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_User_Group_Type]: ['WB_MDSET_ID','USRGRPM_ID'],

})


//-- Other Foreign Keys without jsData  Relationship
_.defaults(dctNonParentForeignKeysByEntitySet, {})


//-- Key Pools
_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_User_Group_Relationship]: {sequence_name: "/AZR/WB_USRGRPR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_User_Group_SalesArea]: {sequence_name: "/AZR/WB_USRGRPSAR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_User_Group_Type]: {sequence_name: "/AZR/WB_USRGRPM_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_User_Group_Hierarchy]: {sequence_name: "/AZR/WB_USRGRPH_SEQ", ...KeyGenSpecs_default},

})